// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ygihibkhidccemxhrtxy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlnaWhpYmtoaWRjY2VteGhydHh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4NzM0MTAsImV4cCI6MjA2MTQ0OTQxMH0.82C8KWlx1QSIkck-LuWNRHMrRautEhR7YhUyuRS4zuY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);